<div style="min-width:400px;">
  <div style="width:98%;">
  <span> <button class="btn btn border" (click)="saveElectableSign()">Spara</button>  <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br><hr />
 <form [formGroup]="form">

  <div class="row">

   <div class="col-md-12">
     <label>
       Utmärkelse
     </label>
     <div class="row">
    <div class="col-md-6">
     <input id="signName" type="text" class="form-control form-control-sm" formControlName="signName" disabled>
    </div>
    <div class="col-md-6">
     <p-select [options]="signlist" filter="true" [showClear]="false" formControlName="signName" optionLabel="name" [style]="{'width':'100%'}" (onChange)="getSignTypeBySignId($event)" appendTo="body"></p-select>
    </div>
  </div>
   </div>
  </div>

  <div class="row">
   <div class="col-md-12">
     <label>
       Förkortning
     </label>
     <div class="row">
       <div class="col-md-6">
     <input id="signAbbreviation" type="text" class="form-control form-control-sm" formControlName="signAbbreviation" disabled>
    </div>
    <div class="col-md-6">
     <p-select [options]="signlist" filter="true" [showClear]="false" formControlName="signAbbreviation" optionLabel="abbreviation" [style]="{'width':'100%'}" (onChange)="getSignTypeBySignId($event)" appendTo="body"></p-select>
    </div>
    </div>
   </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <label>
        Institution
      </label>
      <div class="row">
      <div class="col-md-6">
        <input id="institutionIdName" type="text" class="form-control form-control-sm" disabled formControlName="institutionIdName">
      </div>
      <div class="col-md-6">
      <p-select [options]="institutionlist" filter="true" [showClear]="false" formControlName="shortName" optionLabel="name" [style]="{'width':'100%'}" (onChange)="setInstitution($event)" appendTo="body"></p-select>
    </div>
    </div>
    </div>
   </div>

   <div class="row">
    <div class="col-md-12">
      <label>
        Institutionstyp
      </label>
      <div class="row">
        <div class="col-md-6">
          <input id="institutionTypeId" type="text" class="form-control form-control-sm" disabled formControlName="institutionTypeIdName">
        </div>
        <div class="col-md-6">
      <!--input id="institutionTypeIdName" type="text" class="form-control form-control-sm" formControlName="institutionTypeIdName"-->
      <p-select appendTo="body" [options]="institutiontypes" formControlName="institutionTypeId" [style]="{'width':'100%'}" (onChange)="setInstitutionType($event)"></p-select>
    </div>
    </div>
   </div>
   </div>
   </form>
  </div>
 </div>


